
import { all } from 'redux-saga/effects';

import { watchGetAnalyze } from './analyze';
import {
    watchAnalyze2Opsub,
    watchGetOpsubNew,
    watchGetOpsubOld
} from './analyze2opsub';
import {
    watchAnalyzeDefunctPar,
    watchGetOpsubActual
} from './analyzeDefunctPar';
import { watchGetKatuzeInfo } from './isknActual';
import { watchGetKatuze } from './katuze';
import { watchGetOpsub } from './opsub';
import { watchGetParHistory } from './parHistory';
import { watchProject } from './project';
import { watchGetProjectList } from './projectList';
import {
    watchGetParamsValues,
    watchSearchObject
} from './search';
import { watchGetTel } from './tel';

import {
    watchGetObjectOpsub,
    watchGetObjectParcela,
    watchGetObjectTeleso
} from './info';

import serverApi from '../common/client/serverApi';
import { authFlow } from '../common/client/sagas/auth';
import { keepConnectionWorkFlow } from '../common/client/sagas/keepConnection';

import history from '../history';

export default function* rootSagas() {
    const options = {
        history: history,
        serverApi: serverApi
    };

    yield all([
        watchAnalyze2Opsub(options),
        watchAnalyzeDefunctPar(options),
        watchGetAnalyze(options),
        watchGetKatuze(options),
        watchGetKatuzeInfo(options),
        watchGetOpsub(options),
        watchGetOpsubActual(options),
        watchGetParHistory(options),
        watchGetTel(options),
        watchProject(options),
        watchGetProjectList(options),
        watchGetParamsValues(options),
        watchSearchObject(options),
        watchGetObjectOpsub(options),
        watchGetObjectParcela(options),
        watchGetObjectTeleso(options),
        watchGetOpsubNew(options),
        watchGetOpsubOld(options),
        keepConnectionWorkFlow(options),

        authFlow({
            ...options,
            afterLogoutUrl: '/'
        })
    ]);
}
